import { transitionChildrensBookChapterSceneManagementV1B } from './childrensBookChapterSceneManagementV1B';

const clean = value => String(value ?? '').trim();
const reject = code => ({ ok: false, code });

function existingChapters(outline) {
  if (outline == null) return [];
  if (outline?.version !== 1 || !Array.isArray(outline.chapters)) return null;
  return outline.chapters;
}

// All changes remain local until the existing Save Blueprint operation.
// The existing server-side v1 validator remains the persistence authority.
export function addChildrensBookChapterV1E4T({ units = [], outline, id, title } = {}) {
  const chapters = existingChapters(outline);
  if (!chapters) return reject('unsupported_saved_outline');
  const changed = transitionChildrensBookChapterSceneManagementV1B({
    units, chapters, action: { type: 'add_chapter', id: clean(id), title: clean(title) },
  });
  return changed.ok ? { ok: true, outline: { version: 1, chapters: changed.chapters } } : reject(changed.code);
}

// Create AND assign one real manuscript page in the same local transition.
// Empty Scenes are forbidden by the backend. Never fabricate a page or Canon Scene.
export function addChildrensBookSceneV1E4T({ units = [], outline, chapterId, id, title, unitId } = {}) {
  const chapters = existingChapters(outline);
  if (!chapters) return reject('unsupported_saved_outline');
  if (!clean(unitId)) return reject('select_existing_page_or_spread');
  const added = transitionChildrensBookChapterSceneManagementV1B({
    units, chapters, action: { type: 'add_scene', chapterId: clean(chapterId), id: clean(id), title: clean(title) },
  });
  if (!added.ok) return reject(added.code);
  const assigned = transitionChildrensBookChapterSceneManagementV1B({
    units, chapters: added.chapters,
    action: { type: 'assign_unit', chapterId: clean(chapterId), sceneId: clean(id), unitId: clean(unitId) },
  });
  return assigned.ok ? { ok: true, outline: { version: 1, chapters: assigned.chapters } } : reject(assigned.code);
}
